<template>
  <div class="create-group-modal">
    <b-button v-required-role="'ROLE_BACKOFFICE_GROUP_POST'" @click="openModal" size="sm" variant="success">{{ $t('btn.add') }}</b-button>
    <b-modal
        ref="create-security-role-modal"
        size="lg"
        :hide-footer="isLoading"
    >
      <div v-if="isLoading" class="d-flex justify-content-center m-5">
        <div class="spinner-border text-primary">
          <span class="sr-only">{{$t('state.loading')}}</span>
        </div>
      </div>
      <template v-if="!isLoading" #modal-header>
        <div class="w-100 d-flex justify-content-between align-items-center">
          <h4>{{ $t('roles.add_new_role.title') }}</h4>
          <div class="d-flex">
            <b-button type="button" class="mr-1" variant="secondary" @click="hideModal">{{ $t('btn.cancel') }}</b-button>
            <b-button variant="primary" @click="saveRole">{{ !isEditForm ? $t('btn.add') : $t('btn.edit') }}</b-button>
          </div>
        </div>
      </template>
      <b-form-group
          v-required-role="'ROLE_BACKOFFICE_GROUP_POST'"
          :label="$t('roles.add_new_role.role_name')"
          label-for="role-name"
      >
        <b-form-input
            v-model="roleName"
            @input="$v.roleName.$model = $event"
            :readonly="isEditForm"
            :state="!$v.roleName.$dirty ? null :(!$v.roleName.$error)"
            trim></b-form-input>
        <p v-if="$v.roleName.$dirty && !$v.roleName.required" class="text-danger">{{ $t('roles.errors.required') }}</p>
      </b-form-group>
      <b-form-group
          v-required-role="'ROLE_BACKOFFICE_GROUP_POST'"
          :label="$t('roles.add_new_role.role_category')"
          label-for="role-name"
      >
        <b-form-input
            v-model="roleCategory"
            @input="$v.roleCategory.$model = $event"
            :state="!$v.roleCategory.$dirty ? null :(!$v.roleCategory.$error)"
            trim></b-form-input>
        <p v-if="$v.roleCategory.$dirty && !$v.roleCategory.required" class="text-danger">{{ $t('roles.errors.required') }}</p>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox
            id="roleIsSpecial"
            v-model="roleIsSpecial"
            name="roleIsSpecial"
            :value="true"
        >
          {{ $t('form.is_special') }}
        </b-form-checkbox>
      </b-form-group>
      <template v-if="!isLoading" #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button type="button" class="mr-1" variant="secondary" @click="hideModal">{{ $t('btn.cancel') }}</b-button>
          <b-button variant="primary" @click="saveRole">{{ !isEditForm ? $t('btn.add') : $t('btn.edit') }}</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import axios from "axios";
  import { required } from 'vuelidate/lib/validators';
  import alertify from 'alertifyjs';

  export default {
    data() {
      return {
        isEditForm: false,
        isLoading: true,
        roleName: '',
        roleCategory: '',
        roleIsSpecial: false,
        errors: {
          required: 'This field is required!'
        }
      }
    },
    validations: {
      roleName: {
        required
      },
      roleCategory: {
        required
      }
    },
    methods: {
      saveRole() {
        this.$v.$touch();

        if(!this.$v.$invalid) {
          const httpMethod = this.isEditForm ? 'put' : 'post';

          const payload = {
            role: this.roleName,
            isSpecial: this.roleIsSpecial,
            category: this.roleCategory
          }

          const url = this.isEditForm ? `/api/role/${this.roleName}` : '/api/role?limit=200'

          axios[httpMethod](url, payload)
            .then(() => {
              this.hideModal();
              this.$emit('savedRoles')
            })
            .catch(error => {
              alertify.error(error.response.data.label);
            });
        }
      },
      openModal(item) {
        this.resetProperties();

        if(item && item.role) {
          this.setEditData(item);
        } else {
          this.isLoading = false;
        }

        this.$refs['create-security-role-modal'].show();
      },
      hideModal() {
        this.$refs['create-security-role-modal'].hide();
      },
      setEditData(item) {
        if(item) {
          this.roleName = item.role;
          this.roleCategory = item.category;
          this.roleIsSpecial = item.isSpecial;
          this.isLoading = false;
          this.isEditForm = true;
        }
      },
      resetProperties() {
        this.isLoading = true;
        this.isEditForm = false;
        this.roleName = '';
        this.roleCategory = '';
        this.roleIsSpecial = false;
        this.$v.$reset();
      }
    }
  }
</script>

<style>

</style>
